export default {"src":"/_next/static/media/upload2.2264863e.svg","height":41,"width":262,"blurWidth":0,"blurHeight":0};